import script from "./BodegaView.vue?vue&type=script&setup=true&lang=js"
export * from "./BodegaView.vue?vue&type=script&setup=true&lang=js"

import "./BodegaView.vue?vue&type=style&index=0&id=4416e409&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4416e409"]])

export default __exports__